<template >
    <el-dialog :before-close="handleClose" width="800px" :title="'Email ' + this.Nume + ' / ' +  format(this.selectedObject.Data)" :visible.sync="showPopup">

        <p class="message-content">{{ selectedObject.Subiect }}</p>

        <iframe style="width:100%; height:70vh; pointer-events: none;"
            :srcdoc="selectedObject.Continut"
            frameborder="1">
        </iframe>
           
    </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import moment from 'moment';
export default {
    name: 'Preview_email',
    extends: BasePage,
    data() {
        return {
            Nume: '',
            showPopup: false,
            selectedObject: {
                Subiect: '',
                Continut: '',
            }
        }
    },
    methods: {
        handleClose() {
            console.log( document.documentElement.style.getPropertyValue(PointerEvent))
            document.querySelector('body').style.setProperty("pointer-events", "unset");
            // document.documentElement.style.setProperty("pointer-events", "auto");
            this.showPopup = false;
        },
        format(data) {
            return moment(data).format('DD.MM.YYYY HH:mm')
        },
        async get_info(id) {
            let args = { Id: id };
            let res = await this.post('admin/log_email/get_info_for_email', args);
            if (res.Raspuns) {
                this.selectedObject = res.Raspuns;

            }
        },
        show_me(id, nume) {
            this.Nume = nume;
            this.get_info(id);
            this.showPopup = true;

        }
    }
}
</script>


<style lang="less">
.content {
    // width: 700px;
    width: 100%;
    img {
        width: 100%;
    }

    .header-email {
        width: 100%;
        margin-bottom: 20px;

        .logo{
            width: 60%;


            .logo {
                width: 100%;
            }
        }

        .title {
            width: 40%;
            text-align: end;

            .span {
                font-size: 36px;
                color: #f9a02c;
                font-weight: 800;
            }
        }
    }

    .main {
        margin: 0;
        padding: 10px 20px;
        max-width: 100%;
        width: 100%;
        vertical-align: center;
        background-color: #f9a02c;

        h2 {
            color: white;
            font-size: 14px;
            padding: 0;
            margin: 0;
        }
    }

    .main-2 {
        margin-top: 10px;
        padding: 10px 20px;
        max-width: 100%;
        width: 100%;
        border-left: 5px solid #f9a02c;
        border-radius: 3px;

        p {
            font-size: 11px;
            font-weight: 700;
            color: rgb(49, 49, 49);

            span {
                font-size: 13px;
                font-weight: 700;
            }
        }

        a {
            text-decoration: none;
            color: #f9a02c;
            font-size: 14px;
        }

        a:hover {
            text-decoration: underline;
        }
    }

}
</style>